import React from 'react';
import DataTable from '../../components/dataTable';
import useStore from '../../hooks/use-store';
import {canSeeAuditFields} from '../../helpers/auth';

const UserTable = (props) => {
    const {store} = useStore();
    const showAuditFields = canSeeAuditFields(store.auth.profile);
    const {
        userForm,
        removeRegister,
        attributes,
        list,
        permissions,
        loading,
        intl,
    } = props;

    return (
        <DataTable
            add={userForm}
            edit={userForm}
            remove={removeRegister}
            list={list}
            loading={loading}
            attributes={attributes}
            permissions={permissions}
            keyField={'id'}
            confirmText={intl.formatMessage({id: 'userRemoveConfirm'})}
            headers={[
                {title: 'sharedName', field: 'name', dataSort: true, width: 390},
                {title: 'userEmail', field: 'email', dataSort: true, width: 370},
                {title: 'sharedDisabled', field: 'disabled', dataSort: false, width: 130},
                {title: 'sharedCustomer', field: 'customerName', dataSort: true, width: 340},
                ...(showAuditFields ? [
                    {title: 'sharedCreatedBy', field: 'creatorName', dataSort: true, width: 310},
                    {title: 'sharedCreatorEmail', field: 'creatorEmail', dataSort: true, width: 330},
                    {title: 'sharedCreatedAt', field: 'createdAtFormatted', dataSort: true, width: 210},
                    {title: 'sharedUpdatedAt', field: 'updatedAtFormatted', dataSort: true, width: 210},
                ] : []),
            ]}
            excelConfig={{
                fileName: 'deviceTitle',
                columns: [
                    {label: 'sharedName', field: 'name'},
                    {label: 'userEmail', field: 'email'},
                    {
                        label: 'sharedDisabled',
                        field: (col) => col.disabled ? intl.formatMessage({id: 'sharedYes'}) : intl.formatMessage({id: 'sharedNo'}),
                    },
                    {label: 'sharedPhone', field: 'phone'},
                    ...(showAuditFields ? [
                        {label: 'sharedCreatedBy', field: 'creatorName'},
                        {label: 'sharedCreatorEmail', field: 'creatorEmail'},
                        {label: 'sharedCreatedAt', field: 'createdAtFormatted'},
                        {label: 'sharedUpdatedAt', field: 'updatedAtFormatted'},
                    ] : []),
                ],
            }}
        />);
};

export default UserTable;
